<template>
  <div class="reward-detail">
    <div class="money">
      <div>
        <!-- 提现 -->
        <span v-if="detail.transaction_type=='1'">{{$t(langKey+'.type1')}}</span>
        <!-- 奖励 -->
        <span v-else-if="detail.transaction_type=='3'">{{$t(langKey+'.type2')}}</span>
        <div><span v-if="detail.transaction_type=='1'">-</span><span v-else-if="detail.transaction_type=='3'">+</span>{{detail.amount}}</div>
      </div>
    </div>
    <div class="detail">
      <div class="item">
        <div>{{$t(langKey+'.item1')}}</div>
        <!-- 提现 -->
        <div v-if="detail.transaction_type=='1'">{{$t(langKey+'.type1')}}</div>
        <!-- 奖励 -->
        <div v-else-if="detail.transaction_type=='3'">{{$t(langKey+'.type2')}}</div>
      </div>
      <div class="item">
        <div>{{$t(langKey+'.item2')}}</div>
        <div>{{detail.pay_date}}</div>
      </div>
      <div class="item">
        <div>{{$t(langKey+'.item3')}}</div>
        <div v-if="detail.status == '0'">{{$t(langKey+'.status3')}}</div>
        <div v-else-if="detail.status == '1'">{{$t(langKey+'.status1')}}</div>
        <div v-else-if="detail.status == '2'">{{$t(langKey+'.status2')}}</div>
      </div>
      <div class="item reason" v-if="detail.status=='2'">
        <div>{{$t(langKey+'.item4')}}</div>
        <div>{{detail.transaction_resp_message}}</div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
import { mapGetters } from 'vuex'
import { getIncomeDetail } from 'api/me'
export default {
  data() {
    return {
      langKey: this.$route.name,
      detail: {}
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  created() {
    this._getIncomeDetail(this.$route.params.orderId)
  },
  mixins: [setTitle],
  methods: {
    _getIncomeDetail(orderId) {
      this.$loading.open()
      getIncomeDetail(orderId).then(res => {
        console.log(res)
        this.detail = res.data
        this.$loading.close()
      }).catch(err => {
        console.error(err)
        this.$loading.close()
      })
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .reward-detail{
    min-height: 100vh;
    background: #fff;
    >.money{
      text-align: center;
      height: size(280);
      @include border('bottom');
      @include flex();
      color: #333;
      >div{
        >span{
          font-size: size(26);
          font-weight: 600;
        }
        >div{
          font-size: size(60);
          margin-top: size(32);
        }
      }
    }
    >.detail{
      padding: size(40) size(60);
      font-size: size(30);
      .item{
        @include flex();
        padding: size(14) 0;
        justify-content: space-between;
        &.reason{
          align-items: flex-start;
          line-height: 1.3;
        }
        >div{
          &:first-child{
            width: size(180);
            color: #999;
          }
          &:last-child{
            width: calc(100% - #{size(180)});
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/me/reward-detail.vue